module.exports = __webpack_public_path__ + "h5/img/USDT.60dfd368.png";